/* BaseCamper Favorites ("Saved") — v1, account-free localStorage.
 * First-party by design: data shape {id, handle, ts} + schema version so saves
 * can associate to a customer profile the moment contact/account is captured.
 * Storage key: bc-saved-v1 (JSON array, newest first).
 */
(function () {
  'use strict';

  var KEY = 'bc-saved-v1';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) { /* private mode / quota — degrade silently */ }
    document.dispatchEvent(new CustomEvent('bc:saved-changed', { detail: { count: items.length } }));
  }

  var BCFavorites = {
    all: read,
    count: function () { return read().length; },
    isSaved: function (id) {
      id = String(id);
      return read().some(function (i) { return String(i.id) === id; });
    },
    add: function (id, handle) {
      var items = read();
      id = String(id);
      if (items.some(function (i) { return String(i.id) === id; })) return;
      items.unshift({ id: id, handle: handle || '', ts: Date.now() });
      write(items);
    },
    remove: function (id) {
      id = String(id);
      write(read().filter(function (i) { return String(i.id) !== id; }));
    },
    toggle: function (id, handle) {
      if (this.isSaved(id)) { this.remove(id); return false; }
      this.add(id, handle);
      return true;
    },
    sync: function () { syncButtons(); syncBadge(); }
  };

  window.BCFavorites = BCFavorites;

  function syncButtons(root) {
    var btns = (root || document).querySelectorAll('[data-bc-save]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var saved = BCFavorites.isSaved(btn.getAttribute('data-product-id'));
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var lbl = btn.querySelector('.bc-save-btn__label');
      if (lbl) lbl.textContent = saved ? (btn.getAttribute('data-label-saved') || 'Saved') : (btn.getAttribute('data-label-save') || 'Save');
    }
  }

  function syncBadge() {
    var n = BCFavorites.count();
    var bubbles = document.querySelectorAll('.js-bc-saved-bubble');
    for (var i = 0; i < bubbles.length; i++) {
      bubbles[i].hidden = n === 0;
      var num = bubbles[i].querySelector('.js-bc-saved-count');
      if (num) num.textContent = n < 100 ? String(n) : '99+';
    }
  }

  /* One delegated listener — survives AJAX-filtered grid re-renders */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-bc-save]') : null;
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();
    BCFavorites.toggle(btn.getAttribute('data-product-id'), btn.getAttribute('data-product-handle'));
    btn.classList.add('bc-save-btn--pop');
    setTimeout(function () { btn.classList.remove('bc-save-btn--pop'); }, 250);
  });

  document.addEventListener('bc:saved-changed', function () { syncButtons(); syncBadge(); });

  /* Cross-tab sync */
  window.addEventListener('storage', function (evt) {
    if (evt.key === KEY) { syncButtons(); syncBadge(); }
  });

  /* New cards injected by filtering/pagination get their state painted */
  var debounce;
  function observe() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () { syncButtons(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    syncButtons();
    syncBadge();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
